import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("绑定")

import {computed, ref, watch} from "vue";
import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import {ElMessage, ElTable} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  props: {
    isShow: { type: Boolean },
    orders: null
  },
  emits: ['refresh'],
  setup(__props: any, { emit }) {

const props = __props as {
  isShow: boolean,
  orders: any[]
}

const {
  // 订单收款_无订单收款列表
  'POST/order/receipt/without_order_records': recordsApi,
  // 订单收款_无订单收款单绑定订单
  'POST/order/receipt/bind_order': bind_order_api,
} = Api


const multipleTableRef = ref<InstanceType<typeof ElTable>>()
const show = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const selectionRows = ref<any[]>([])
watch(() => props.isShow, (n, o) => {
  if (n) {
    show.value = n
    refreshPageData()
  }
})
watch(() => selectionRows.value, (n, o) => {
  if (props.orders.length > 1 && n.length > 1) {
    multipleTableRef.value && multipleTableRef.value.toggleRowSelection(n[1], false)
    ElMessage.success('多个订单合并收款时，只能选择一个收款单，并且满足全额支付')
  }
})

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(recordsApi)
const refreshPageData = () => {
  page.value = 1
  fetchData({tradeState: "SUCCESS", queryType: 1})
}
const onClick = () => {
  isLoading.value = true
  bind_order_api({
    orderIds: props.orders.map(i => i.id),
    payRecordIds: selectionRows.value.map(i => i.id)
  }).then((r: any) => {
    isLoading.value = false
    ElMessage.success('绑定订单成功')
    show.value=false
    emit("refresh")
  }).catch(() => {
    isLoading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((show).value = $event)),
      title: "收款单列表",
      width: "900",
      class: "without-order-record-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (show.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isLoading.value,
          disabled: isLoading.value,
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _withDirectives((_openBlock(), _createBlock(_unref(ElTable), {
            onSelectionChange: _cache[0] || (_cache[0] = (rows) => selectionRows.value = rows),
            ref_key: "multipleTableRef",
            ref: multipleTableRef,
            border: "",
            data: _unref(MI_tableData),
            "max-height": _unref(MI_height) - 60 + 'px'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                fixed: ""
              }),
              _createVNode(_component_el_table_column, {
                label: "金额",
                prop: "paymentAmount",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                prop: "createTime",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "创建人",
                prop: "userName",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                label: "支付状态",
                prop: "tradeStateDesc",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "收款方式",
                prop: "payType",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "备注",
                prop: "note",
                "min-width": "100",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data", "max-height"])), [
            [_directive_loading, _unref(MI_identify)]
          ]),
          _createVNode(_component_el_pagination, {
            background: "",
            small: "",
            class: "mt-20",
            disabled: _unref(MI_identify),
            total: _unref(MI_total),
            currentPage: _unref(page),
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            "page-size": _unref(size),
            "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
            "page-sizes": [30, 50, 100, 500],
            layout: "sizes, prev, pager, next, total, jumper",
            onCurrentChange: _unref(MI_pageChange),
            onSizeChange: _unref(MI_sizeChange)
          }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})